module.exports = __webpack_public_path__ + "img/ring-billed-gull.c389a098.jpg";